import React, { useEffect, Fragment, useState, useContext } from 'react';
import './Header.scss';
import logoCaletaEnLinea from '../../assets/CaletaEnLineaLogoV3.svg';
import logo_min_chile1 from '../../assets/header-icons/logo_min_chile1.svg'
import logo_min_chile2 from '../../assets/header-icons/logo_min_chile2.svg'
import logo_min_chile3 from '../../assets/header-icons/logo_min_chile3.svg'
import ifop from '../../assets/header-icons/ifop.svg'
import coronavirus from '../../assets/header-icons/coronavirus.svg'
import { Link, NavLink, useHistory } from 'react-router-dom';
import { ResourcesContext } from '../ContextProvider';
import { uiContext, UIComponentAndProvider } from '../common';
import lupaVideo from '../../assets/header-icons/lupa_video.svg';
import YoutubeVideoOverlay from '../common/videoComponent/video';
import WWFIcon from '../../assets/header-icons/WWFIcon.svg';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu'

const Header = ({ headerState = "home" }) => {
    /**
     * Componente Header
     * Es el encargado de mostrar las direfentes opciones al usuario visitante
     */
    const uicontext = useContext(uiContext);
    const history = useHistory();
    let url = 'http://media.w3.org/2010/05/bunny/movie.mp4';
    const resources = useContext(ResourcesContext)
    const [caletas, setCaletas] = useState(0);
    const [pescadores, setPescadores] = useState(0);
    const [mujeres, setMujeres] = useState(0);
    const [hombres, setHombres] = useState(0);
    const [showModalVideo, setShowModalVideo] = useState(false);
    const [showFloatMenu, setShowFloatMenu] = useState(false);
    

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Fragment>
            <HeaderMenu/>
            <div className="headerMasterContainer">
                <div className="headerGridContainer">
                    <div className="sernapescaLogosContainer">
                        <img className="logo" onClick={() => { window.open('https://www.economia.gob.cl/', '_blank') }} src={logo_min_chile1} alt="Min 1"></img>
                        <img className="logo" onClick={() => { window.open('http://www.subpesca.cl/portal/616/w3-channel.html', '_blank') }} src={logo_min_chile2} alt="Min 2"></img>
                        <img className="logo" onClick={() => { window.open('http://www.sernapesca.cl/', '_blank') }} src={logo_min_chile3} alt="Min 3"></img>
                        <img className="logo coro" onClick={() => { window.open('https://www.minsal.cl/nuevo-coronavirus-2019-ncov/', '_blank') }} src={coronavirus} alt="Coronavirus"></img>
                    </div>

                    <div className="otherLogosContainer">
                        <img className="logo ifop" onClick={() => { window.open('https://www.wwf.cl/', '_blank') }} src={WWFIcon} alt="WWF"></img>
                        <img className="logo ifop" onClick={() => { window.open('https://www.ifop.cl/', '_blank') }} src={ifop} alt="Ifop"></img>
                        {/*<img className="logo shell" onClick={() => { window.open('https://www.shellcatch.com', '_blank') }} src={shellcatch} alt="Shellcatch"></img>*/}
                        {/*<img className="logo fao" onClick={() => { window.open('http://www.fao.org/home/es/', '_blank') }} src={caletaMesa} alt="FAO"></img>*/}
                    </div>

                    <div className="caletaEnLineaLogoContainer">
                        <Link className="caletaEnLinea" to="/home">
                            <img className="" src={logoCaletaEnLinea} alt="Caleta en linea"></img>
                        </Link>
                    </div>

                    <div className="numbersContainer">
                        <div className="countContainer">
                            <div className="number">{uicontext.caletasCount}</div>
                            <div className="text">Caletas</div>
                        </div>
                        <div className="countContainer">
                            <div className="number">{uicontext.mujeresCount + uicontext.hombresCount}</div>
                            <div className="text">Pescadores</div>
                        </div>
                        <div className="countContainer">
                            <div className="number">{uicontext.mujeresCount}</div>
                            <div className="text">Mujeres</div>
                        </div>
                        <div className="countContainer">
                            <div className="number">{uicontext.hombresCount}</div>
                            <div className="text">Hombres</div>
                        </div>
                        <div className="lupaContainer">
                            <img className="lupaVideo" onClick={() => { window.scrollTo(0, 0); setShowModalVideo(true); document.body.style.overflow = 'hidden'; }} src={lupaVideo} alt="Lupa video"></img>
                        </div>
                    </div>
                </div>

                <div className="optionsContainer">
                    <div className={(headerState === 'home' ? 'optionSelected' : "") + " option"} onClick={() => { history.push("/home"); }} >
                        <span className="bold title">Acceso caletas en línea</span>
                    </div>

                    <div className={(headerState === 'marineareas' ? 'optionSelected' : "") + " option"} onClick={() => { history.push("/areas-marinas"); }}>
                        <span className="bold title">Parques y reservas marinas</span>
                    </div>

                    <div className={(headerState === 'conservacion' ? 'optionSelected' : "") + " option"} onClick={() => { history.push("/conservacion-sustentabilidad"); }}>
                        <span className="bold title">Conservación y sustentabilidad</span>
                    </div>

                    <div className="option optionColumn" onClick={() => { window.open("https://micaleta.sernapesca.cl/#/login", "_blank"); }}>
                        <span className="bold title">Mi caleta</span>
                        <span className="subtitle">Trámites y servicios Sernapesca</span>
                    </div>

                    <div className="option">
                        <div onClick={() => { setShowFloatMenu(showFloatMenu => !showFloatMenu); }} className="dropdownOptions">
                            <span className="bold title">Buenas prácticas del pescador</span>
                        </div>
                        <div onClick={() => { setShowFloatMenu(false); window.open("http://www.sernapesca.cl/sites/default/files/manual_bbpp_version_final_0.pdf", "_blank");}} className={(showFloatMenu==true ? "dropdwonSubMenu0Visible" : "dropdwonSubMenuHidden") + " dropdownSubmenu"}>
                            <span className="bold title">Manual de buenas prácticas</span>
                        </div>

                        <div onClick={() => { setShowFloatMenu(false); history.push("/protocolo-covid-19");}} className={(showFloatMenu==true ? "dropdwonSubMenu1Visible" : "dropdwonSubMenuHidden") + " dropdownSubmenu"} >
                            <span className="bold title">Protocolo COVID-19</span>
                        </div>
                    </div>

                    <div className={(headerState === 'register' ? 'optionSelected' : "") + " option"} onClick={() => { history.push("/registrar-caleta");}}>
                        <span className="bold title">Inscríbete aquí</span>
                    </div>
                </div>

            </div>
            <YoutubeVideoOverlay SetShowOverlay={setShowModalVideo} ShowOverlay={showModalVideo} />
        </Fragment>
    )
}

export default Header;